import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService} from './auth.service';

@Injectable()
export class SettingsService {
  isLoaded: boolean = false;
  isActual: boolean = false;
  errorText: string = "";
  successText: string = "";
  successPasText: string = "";
  isFirst: boolean = true;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };
  constructor(private http: HttpClient, private authService: AuthService) { 
    
  }

  updateUser(editedData){ 
    this.authService.notify = "";
    this.http.post(this.authService.databaseURL+'updatedata.php?table=user', editedData, this.httpOptions).subscribe(
      (data:any[]) => {
        localStorage.setItem("settingsUser", editedData.settings);
        localStorage.setItem("emailUser", editedData.email);
        localStorage.setItem("menuImage", editedData.menuImage);
        this.authService.menuImage = editedData.menuImage;
        this.successText = "Uspech";
      },  
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
  }

  updateUserPas(editedData){ 
    this.authService.notify = "";
    let params = {
      "id": editedData.id,
      "login": editedData.login,
      "newPassword": editedData.newPassword,
      "oldPassword": editedData.oldPassword
    }
    if(editedData.newPassword != editedData.newPasswordAgain){
      this.errorText = "Kontrolní heslo se neshoduje.";
    }
    else if(editedData.newPassword.length < 7){
      this.errorText = "Heslo musí mít alespoň 7 znaků.";
    }
    else{
      this.http.post(this.authService.databaseURL+'getdata.php?table=userpas', editedData, this.httpOptions).subscribe(
        (data:any[]) => {
          
          if(data.length == 1){
            this.http.post(this.authService.databaseURL+'updatedata.php?table=userpas', params, this.httpOptions).subscribe(
              (data:any[]) => {
                this.successPasText = "Heslo bylo úspěšně změněno";
            }
          );
          }
          else{
            this.errorText = "Současné heslo nebylo správně zadáno.";
          }
        }
      ),  
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
  }

  }

  incState(){ 
    this.authService.notify = "";
    let params = {
      "idUser": localStorage.getItem("idUser")
    }
    this.http.post(this.authService.databaseURL+'updatedata.php?table=userincstate', params, this.httpOptions).subscribe(
      (data:any[]) => {
        this.isActual = true;
        localStorage.setItem("stateUser", "1");
        this.isFirst = false;
        this.authService.redirectToHome();
      }
    ),  
    error => {
      this.authService.notify = "Nepodařilo se spojit s databází. Zkontrolujte prosím Vaše internetové připojení.";
      this.isActual = false;
    }

  }

  initData(){ 
    this.authService.notify = "";
    let params = {
      "idUser": localStorage.getItem("idUser"),
      "id": Date.now() + "-" + localStorage.getItem("idUser").slice(-9)
    }
    this.http.post(this.authService.databaseURL+'adddata.php?table=userinit', params, this.httpOptions).subscribe(
      (data:any[]) => {
        this.isActual = true;
        localStorage.setItem("stateUser", "1");
        this.isFirst = false;

      }
    ),  
    error => {
      this.authService.notify = "Nepodařilo se spojit s databází. Zkontrolujte prosím Vaše internetové připojení.";
      this.isActual = false;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/services/settings.service.ts